export default "__VITE_ASSET__DmANTvv0__"